import type { PublicTenant } from '../../shared/public-tenant';
import { defaultArea, firstBookableArea } from '../../shared/areas';

/**
 * `?area=<код>` в адресах клиента: у раздела по умолчанию (первого) параметра нет — старые
 * ссылки /book и /queue ведут туда же, куда и раньше.
 */
export function areaSearch(tenant: Pick<PublicTenant, 'areas'>, code: string | null | undefined): string {
  if (!code || code === defaultArea(tenant)?.code) return '';
  return `?area=${encodeURIComponent(code)}`;
}

/** Код раздела из адреса (`?area=`); null — параметра нет. */
export function areaParam(search: string): string | null {
  const value = new URLSearchParams(search).get('area');
  return value ? value : null;
}

/**
 * Кнопка «Записаться» без выбранного раздела: в первый раздел, где запись работает (раздел по
 * умолчанию может быть только с очередью); null — записаться некуда, кнопку не показывать.
 */
export function bookHref(tenant: Pick<PublicTenant, 'areas' | 'status'>): string | null {
  const area = firstBookableArea(tenant);
  return area ? `/book${areaSearch(tenant, area.code)}` : null;
}
